import { mode } from '@chakra-ui/theme-tools';
const baseStyle = {
  tablist: {
    marginBottom: 4,
    gap: 2,
  },
  tabpanel: {
    padding: 0,
  },
};

const sizes = {
  sm: {
    tab: {
      fontSize: 'sm',
      py: 3,
    },
  },
};

const variants = {
  'solid-rounded': props => ({
    tab: {
      borderRadius: 'full',
      bg: mode('blueLight', 'gray.700')(props),
      _selected: {
        bg: 'WPPTeal.300',
        color: 'WPPNavy.300',
      },
    },
  }),
};

const defaultProps = {
  variant: 'solid-rounded',
};

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
